import { render, staticRenderFns } from "./ApprovalIcon.vue?vue&type=template&id=9f147eec"
import script from "./ApprovalIcon.vue?vue&type=script&lang=js"
export * from "./ApprovalIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports